import D3U from '@elem/compPage/D3U';
import { GetStaticPropsContext } from 'next';
import { useRouter } from 'next/router';
import { pathname, theme, sites } from '@elem/compPage/D3U/config/page';
import { ProductProvider, useProductActiveTab } from '@elem/compPage/D3U/ProductProvider';
import { redirectTo404 } from '@/utils/redirect404';
import { useLang } from '@/i18n';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';

export default function Page({ SEO }: { SEO: any }) {
    const { locale = '' } = useRouter();
    const { t } = useLang('d3u');
    const activeTab = useProductActiveTab();

    return (
        <PageLayout isNoFixed={true} theme={theme}>
            <SEO title={t('seo_title')} description={t('seo_desc')} keywords={t('seo_keywords')} />
            <SEOlinksA locale={locale} list={sites} pathname={pathname} />
            <ProductProvider children={<D3U />} activeTab={activeTab || 'Product'} />
        </PageLayout>
    );
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
    // 非白名单404
    if (!sites.includes(locale as string)) {
        return redirectTo404();
    }
    return {
        props: {},
        revalidate: 18000,
    };
}
